import React from 'react';
import { useSelector } from 'react-redux';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';

import { organizationIdSelector } from '@/domain/env/envSelector';
import { toggleEditMode, useEditMode } from '@/lib/i18nOverrides/editMode';

interface Props {
  readonly onClick: () => void;
}

/**
 * Account menu entry that turns text edit mode on and off. POC: no permission check — any signed-in user of an
 * organization may edit its texts. English literal on purpose (design decision 15).
 */
const EditTextsMenuItem = ({ onClick }: Props) => {
  const orgId: unknown = useSelector(organizationIdSelector);
  const editMode = useEditMode();
  if (typeof orgId !== 'string' || orgId === '') return null;
  return (
    <MenuItem
      onClick={() => {
        toggleEditMode();
        onClick();
      }}
    >
      <ListItemIcon>
        <EditNoteOutlinedIcon />
      </ListItemIcon>
      <ListItemText secondary="Ctrl/⌘ + Shift + E">{editMode ? 'Stop editing texts' : 'Edit texts'}</ListItemText>
    </MenuItem>
  );
};

export default EditTextsMenuItem;
